import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../environments/environment';
import { BackLinkComponent } from '../../shared/components/back-link/back-link.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';

interface WorkerJobRow {
  id: number;
  job_type: string;
  entity_type: string | null;
  entity_id: number | null;
  status: string;
  message: string | null;
  attempt_count: number;
  has_llm_data: boolean;
  created_at: string | null;
  completed_at: string | null;
}

@Component({
  selector: 'app-failed-jobs',
  templateUrl: './failed-jobs.component.html',
  styleUrls: ['./failed-jobs.component.scss'],
  standalone: true,
  imports: [
    CommonModule, RouterModule, DatePipe,
    MatButtonModule, MatIconModule, MatTableModule,
    BackLinkComponent, PageHeaderComponent, LoadingSpinnerComponent,
  ],
})
export class FailedJobsComponent implements OnInit {
  dataSource = new MatTableDataSource<WorkerJobRow>();
  displayedColumns = ['job_type', 'entity', 'status', 'message', 'created_at'];

  isLoading = true;
  errorMessage: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.errorMessage = null;
    this.http.get<WorkerJobRow[]>(`${environment.apiUrl}/jobs`).subscribe({
      next: (data) => {
        this.dataSource.data = data;
        this.isLoading = false;
      },
      error: () => {
        this.errorMessage = 'Failed to load jobs.';
        this.isLoading = false;
      },
    });
  }

  statusClass(status: string): string {
    switch (status) {
      case 'complete':    return 'status-complete';
      case 'running':     return 'status-running';
      case 'queued':      return 'status-queued';
      case 'failed':      return 'status-failed';
      case 'dead_letter': return 'status-dead';
      default:            return '';
    }
  }
}
